import { NewStorageOperation } from './new-storage-operation'
import { StorageLocation } from '../nodes/storage-location'

export class StorageOperation {
  public id: string
  public request: NewStorageOperation
  public result: StorageOperationResult

  constructor() {}
}

export class StorageOperationResult {
  public resultType: StorageOperationResultType
  public suitedLocations: StorageLocation[]
  public message: string
}

export enum StorageOperationResultType {
  SUCCESS = 'SUCCESS',

  /**
   * Operation cannot be completed without
   * further input.
   */
  INPUT_REQUIRED = 'INPUT_REQUIRED',

  /**
   * Operation failed.
   */
  FAILED = 'FAILED',
}
